// Who may do what in a community (#18): the legacy methods in collections.js wrote for anyone. Shared with the browser
// (a method's simulation runs the same check on the data the browser has); the server's verdict counts.
// - a manager: an admin, the community's owner (createdBy) or one of its moderators (mods; the owner is one from the
//   start, owners/server/communities.js);
// - a member: a manager, or a fan who follows the community (profile.subs).
import { Meteor } from 'meteor/meteor';
import { isAdmin } from "../core/roles";
export var isManager = function isManager(user, land) {
  return !!user && !!land && (isAdmin(user) || land.createdBy === user._id || (land.mods || []).indexOf(user._id) !== -1);
};
export var isMember = function isMember(user, land) {
  return isManager(user, land) || !!user && !!land && (user.profile && user.profile.subs || []).indexOf(land.id) !== -1;
}; // throws unless the logged-in user is a member (role 'member') or a manager (role 'manager') of the community; with an
// authorId, the author of the post or comment counts as a manager of it. Returns the user.

export var requireCommunityRole = function requireCommunityRole(role, land, authorId) {
  var user = Meteor.user();
  if (!user) throw new Meteor.Error('not-authorized', 'Login required');
  if (!land) throw new Meteor.Error('not-found', 'No such community');
  var allowed = role === 'manager' ? isManager(user, land) || !!authorId && authorId === user._id : isMember(user, land);
  if (!allowed) throw new Meteor.Error('not-authorized', role === 'manager' ? 'Only the community\'s owner or moderators' : 'Only the community\'s members');
  return user;
};